import React from 'react';
import PropTypes from 'prop-types';


import {I18nMessage} from '../../../contexts/I18n';

import styles from './FormFieldError.scss';


function FormFieldError({error}) {

    if (!error) {

        return null;
    }

    return (
        <p className={styles.fieldErrorText}>
            <I18nMessage
                id={error.label}
                values={error.params}
            />
        </p>
    );
}


FormFieldError.propTypes = {
    error: PropTypes.object
};


export default FormFieldError;
